export var CPUCapability;

(function (CPUCapability) {
  CPUCapability["High"] = "high";
  CPUCapability["Low"] = "low";
})(CPUCapability || (CPUCapability = {}));

export var DEFAULT_DEVICE = {
  friendlyName: 'Some Computer',
  capabilities: {
    cssVariables: false,
    cpu: 'high'
  },
  // TODO: switch back to true when LG models are configured
  platform: 'web'
};